import { useEffect, useState } from 'react'

import { isScheduleNow } from 'helpers/scheduleHelpers'

import { IScheduleNotification, Schedule } from './types'
import { fetchNextSchedules } from 'services/me'
import { INextSchedule } from 'services/me/nextSchedules/types'

const formatNextSchedulesData = (schedules: INextSchedule[]): Schedule[] => {
  return schedules.map(({id, startDate, endDate, virtualRoomHash, patientFullName}) => ({
    id,
    startDate,
    endDate,
    virtualRoomHash,
    patientFullName,
  }))
}

export const useScheduleNotification = (): IScheduleNotification => {
  const [nextSchedulesList, setNextSchedulesList] = useState<Schedule[]>([])
  const [scheduleToStart, setScheduleToStart] = useState<Schedule>({} as Schedule)
  const [showNotification, setShowNotification] = useState(false)
  const [timeUp, setTimeUp] = useState(false)

  useEffect(() => {
    const timer = Date.now() >= new Date(scheduleToStart.startDate).getTime()
    setTimeUp(timer)
  }, [scheduleToStart.startDate])

  useEffect(() => {
    async function getNextSchedulesList() {
      const response = await fetchNextSchedules()

      const formattedNextSchedulesData: Schedule[] = formatNextSchedulesData(response)

      setNextSchedulesList(formattedNextSchedulesData)
    }

    void getNextSchedulesList()

  }, [])

  useEffect(() => {
    const checkScheduleDate = () => {
      return nextSchedulesList.forEach(schedule => {
        if (isScheduleNow(schedule.startDate, schedule.endDate)) {
          setScheduleToStart(schedule)
          setShowNotification(true)
        }
      })
    }

    checkScheduleDate()
    const interval = setInterval(checkScheduleDate, 15000)

    return () => clearInterval(interval)
  }, [nextSchedulesList])

  return {
    scheduleToStart,
    showNotification,
    timeUp,
    setTimeUp
  }
}